/*
 * @Author: 向南星 xiangnanxing@scmagic.cn
 * @Date: 2022-09-19 13:56:15
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-11-02 14:23:33
 */
import { EasTabItem, EasTabs } from '@easyvaas/react-components';
import React from 'react';

import styles from './index.module.scss';

import MyImagesList from './MyImagesList';
import MyPropsList from './MyPropsList';
import MyMaterialsList from './MyMaterialsList';
import { useRecoilState } from 'recoil';
import { subTabState } from '../../store/state';

const MyImages = () => {
  const tab = useRecoilState(subTabState(3));
  return (
    <EasTabs
      className={styles.container}
      tabControl={tab}
      tabbarClassName={styles.tabbar}
      tabbarItemClassName={styles.item}
      tabbarItemActiveClassName={styles.active}
    >
      <EasTabItem title="我的座驾">
        <MyImagesList />
      </EasTabItem>
      <EasTabItem title="我的仓库">
        <MyMaterialsList />
      </EasTabItem>
      <EasTabItem title="材料合成">
        <MyPropsList />
      </EasTabItem>
    </EasTabs>
  );
};

export default React.memo(MyImages);
